import { render, staticRenderFns } from "./CalendarDateForm.vue?vue&type=template&id=71d53a96&scoped=true&"
import script from "./CalendarDateForm.vue?vue&type=script&lang=js&"
export * from "./CalendarDateForm.vue?vue&type=script&lang=js&"
import style0 from "./CalendarDateForm.vue?vue&type=style&index=0&id=71d53a96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d53a96",
  null
  
)

export default component.exports